import React from "react";
import Logo from "./../../Images/logo.jpg";
import QuestionMarkIcon from "./../../Images/question-mark.png";
import SaveToCloudIcon from "./../../Images/save-to-cloud.png";
import ExitIcon from "./../../Images/white-x.png";
import { useAuth } from "../../Context/AuthContext";
import { useHistory } from "react-router";

const Header = ({ setHelpModalActive }) => {
  const { logout, saveToDatabase } = useAuth();
  //redirect
  const history = useHistory();

  function handleLogout() {
    logout();
    history.push("/login");
  }

  return (
    <div className="container-header-mobile">
      <img className="header-logo-mobile" src={Logo} alt="logo" />
      <div className="container-header-icons-mobile">
      <img
        className="header-icons-mobile"
        src={QuestionMarkIcon}
        alt="question mark icon"
        onClick={() => setHelpModalActive(true)}
      />

      <img
        className="header-icons-mobile"
        src={SaveToCloudIcon}
        alt="save to cloud icon"
        onClick={saveToDatabase}
      />

      <img
        className="header-icons-mobile"
        src={ExitIcon}
        alt="exit icon"
        onClick={handleLogout}
      />
      </div>
    </div>
  );
};
export default Header;
